import { render, staticRenderFns } from "./DrugCombinationsReportPage.vue?vue&type=template&id=71984992&"
import script from "./DrugCombinationsReportPage.vue?vue&type=script&lang=js&"
export * from "./DrugCombinationsReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports